import { jsx as _jsx } from "react/jsx-runtime";
import { SelectControl } from '@wordpress/components';
import withMetaData from '../../utils/withMetaData';
import { monitorSidebarMetaChange } from '../../api/hubspotPluginApi';
const UISidebarSelectControl = (props) => {
    return (_jsx(SelectControl, { value: props.metaValue, onChange: content => {
            if (props.setMetaValue) {
                props.setMetaValue(content);
            }
            monitorSidebarMetaChange(props.metaKey);
        }, ...props }));
};
export default withMetaData(UISidebarSelectControl);
